import http from "@/services/http";
import { buildUrlFromLocation } from "@/utils/httpUtils";
export default {
    async get(standDesignId) {
        return await http.get(buildUrlFromLocation("/standDesigns/" + standDesignId));
    }
};



// WEBPACK FOOTER //
// ./src/services/currentStandDesign.js